module.exports = __webpack_public_path__ + "img/red_072.635161c7.png";